import { render } from "./MedidasComponent.vue?vue&type=template&id=714c21a4&scoped=true"
import script from "./MedidasComponent.vue?vue&type=script&lang=js"
export * from "./MedidasComponent.vue?vue&type=script&lang=js"

import "./MedidasComponent.vue?vue&type=style&index=0&id=714c21a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714c21a4"]])

export default __exports__